import
{
  CardsContainer,
} from './NewsCards.styles';
import SectionContainer from '../../Containers/SectionContainer/SectionContainer';
import NewsCard from '../../Cards/NewsCard/NewsCard';
import NoResultsText from '../../Typography/NoResultsText/NoResultsText';

// Helpers
import { formatNewsDateString } from '../../../utils/helpers/formatDateString';
import { Skeleton } from '@mui/material';

const NewsCards = ({ articles }) =>
{
  return (
    <SectionContainer
      cardTitle={'News'}
    >
      <CardsContainer
        articles={articles.length > 0 ? 'true' : undefined}
      >
        {
          articles.length > 0 && articles.map(({ id, imageUrl, subject, publishDate, link }) => (
            <NewsCard
              key={id}
              imageUrl={imageUrl}
              title={subject}
              date={formatNewsDateString(publishDate)}
              link={link}
            />
          ))
        }
        {
          articles.length === 0 &&
          <>
            <Skeleton width={'200'} height={200} ></Skeleton>
            <Skeleton width={'40%'} height={163} ></Skeleton>
            <Skeleton width={'40%'} height={163} ></Skeleton>
            {/*           <NoResultsText
              text={'No articles'}
            /> */}
          </>
        }
      </CardsContainer>
    </SectionContainer>
  );
};

export default NewsCards;
